// Petit sélecteur FR | EN pour les écrans pré-connexion (onboarding, login,
// inscription) — la personne doit pouvoir changer de langue AVANT d'avoir un
// compte. Dans les réglages, le sélecteur complet (avec « Automatique »)
// reste la référence ; ici, taper une langue fixe un choix explicite via
// setAppLanguage (persisté, ré-appliqué au prochain lancement).
import { setAppLanguage, type AppLanguage } from "@/i18n";
import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";

const LANGUAGES: { code: AppLanguage; label: string }[] = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

// Les noms de langue s'affichent dans leur propre langue (convention i18n) —
// pas de clé de traduction nécessaire pour ces libellés.
const A11Y_LABELS: Record<AppLanguage, string> = {
  fr: "Français",
  en: "English",
};

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  return (
    <View style={styles.container}>
      {LANGUAGES.map(({ code, label }) => {
        const selected = current === code;
        return (
          <TouchableOpacity
            key={code}
            style={[styles.pill, selected && styles.pillSelected]}
            onPress={() => {
              if (!selected) setAppLanguage(code).catch(() => undefined);
            }}
            accessibilityRole="button"
            accessibilityState={{ selected }}
            accessibilityLabel={A11Y_LABELS[code]}
            hitSlop={8}
          >
            <Text style={[styles.label, selected && styles.labelSelected]}>
              {label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderRadius: 999,
    padding: 3,
    borderWidth: 1,
    borderColor: "#00000014",
    alignSelf: "flex-end",
  },
  pill: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 999,
  },
  pillSelected: {
    backgroundColor: "#1C453F",
  },
  label: {
    fontFamily: "Inter_600SemiBold",
    fontSize: 12,
    color: "#666",
  },
  labelSelected: {
    color: "#FFF",
  },
});
